import QuickSwitchIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import Tooltip from "@mui/material/Tooltip";
import * as labels from "config.labels";
import { useSelector } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as userSelectors from "store/selectors/user/userSelectors";

const StatusQuickSwitch = ({ nextStatus, onChange }) => {
  const isUserReadOnly = useSelector(userSelectors.isUserReadOnly);
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const handleClick = (e) => {
    if (onChange && !isUserReadOnly) {
      onChange(nextStatus);
    }
    e.stopPropagation();
  };

  return (
    <Tooltip
      title={translateLabel(labels.STATUS_QUICK_SWITCH_TOOLTIP, {
        default: "Quickly switch to next status",
      })}
    >
      <QuickSwitchIcon
        className={!isUserReadOnly ? "hover-icon" : ""}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default StatusQuickSwitch;
